
import { Prop, Vue, Component, Watch } from "vue-property-decorator";
import CardContainer from "@/components/CardContainer/index.vue";
import CustomTable from "@/components/CustomTable/index.vue";
import {
  getWorkbenchGoodsRank,
  getWorkbenchGoodsRankShop,
} from "@/api/shouyin";
import { Getter } from "vuex-class";

// 商品排行
@Component({
  components: {
    CardContainer,
    CustomTable,
  },
})
export class GoodsRanking extends Vue {
  @Getter isMultiStore!: boolean;
  @Getter multiStoreList!: Array<any>;

  @Prop({ default: () => ({}) }) params!: any;
  isInit = false;
  columns = [
    {
      key: "goodsName",
      title: "商品名称",
      width: "110",
      textOverflow: "ellipsis",
    },
    {
      key: "totalSaleMoney",
      title: "总额",
      align: "right",
      dataType: "amount",
    },
    {
      key: "totalSaleAmount",
      title: "数量",
      align: "right",
    },
    {
      key: "avgTotalSaleMoney",
      title: "平均售价",
      align: "right",
      dataType: "amount",
    },
  ];
  tableDataSource = [];
  @Watch("params", { deep: true, immediate: true })
  onParamsChange() {
    this.getData();
  }

  async getData() {
    this.isInit = false;
    if (!this.params.storeId && !this.multiStoreList.length) {
      this.isInit = true;
      return;
    }
    const param: any = {
      ...this.params,
      pageSize: 5,
      pageIndex: 1,
    };
    let res: any;
    if (this.isMultiStore) {
      param.storeList = this.multiStoreList.map((item) => {
        return { storeId: item };
      });
      res = await getWorkbenchGoodsRankShop(param);
    } else {
      res = await getWorkbenchGoodsRank(param);
    }
    if (res.code === "000000") {
      this.tableDataSource = res.data.records;
      this.isInit = true;
      console.log("查询商品排行 **", res);
    }
  }
}
export default GoodsRanking;
